import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Summary from './views/Summary.vue';
import ListOrders from './views/ListOrders.vue';
import Download from './views/Download.vue';
import WorkStation from './views/WorkStation.vue';
import Delivery from './views/Delivery.vue';
import Reports from './views/Reports.vue';
import Info from './views/Info.vue';
import Users from './views/Users.vue';

import store from "./store";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
	if (!store.getters.isAuthenticated) {
		next();
		return;
	}
	next("/summary");
};

const ifAuthenticated = (to, from, next) => {
	if (store.getters.isAuthenticated) {
		next();
		return;
	}
	next("/");
};

export default new Router({
	routes: [
		{
			path: '/',
			name: 'login',
			component: Login,
			beforeEnter: ifNotAuthenticated
		},
		{
			path: '/summary',
			name: 'summary',
			component: Summary,
			beforeEnter: ifAuthenticated
		},
		{
			path: '/listOrders/:pageno?',
			name: 'ListOrders',
			component: ListOrders,
			beforeEnter: ifAuthenticated
		},
		{
			path: '/download',
			name: 'Download',
			component: Download,
			beforeEnter: ifAuthenticated
		},
		{
			path: '/workStation',
			name: 'WorkStation',
			component: WorkStation,
			beforeEnter: ifAuthenticated
		},
		{
			path: '/delivery',
			name: 'Delivery',
			component: Delivery,
			beforeEnter: ifAuthenticated
		},
		/*
		{
			path: '/info',
			name: 'Info',
			component: Info,
			beforeEnter: ifAuthenticated
		},*/
		{
			path: '/reports',
			name: 'Reports',
			component: Reports,
			beforeEnter: ifAuthenticated
		},
		{
			path: '/users',
			name: 'Users',
			component: Users,
			beforeEnter: ifAuthenticated
		},
	],
	mode: 'history',
});
